import { Link } from "react-router-dom"
import { SEO } from "@/components/SEO"
import { Card } from "@/components/ui/card"
import { visibleBlogPosts, formatBlogDate } from "@/config/blog"

export function BlogPage() {
  return (
    <>
      <SEO
        title="Blog"
        url="/blog"
        description="Latest news, updates, and insights from the WELEPHANT prediction mining platform."
        keywords="WELEPHANT blog, prediction mining news, blockchain gaming updates, crypto gaming"
      />
      <div className="container py-8">
        {/* Header */}
        <div className="mb-8 max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold tracking-tight mb-2">Blog</h1>
          <p className="text-muted-foreground">
            Latest news, updates, and insights from the WELEPHANT team.
          </p>
        </div>

        {/* Blog Posts Grid - Two Columns */}
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {visibleBlogPosts.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="group">
              <Card className="overflow-hidden h-full hover:bg-muted/50 transition-colors">
                {/* Cover Image */}
                {post.coverImage && (
                  <div className="aspect-video w-full overflow-hidden bg-muted">
                    <img
                      src={post.coverImage}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                )}
                {/* Fallback gradient if no image */}
                {!post.coverImage && (
                  <div className="aspect-video w-full bg-gradient-to-br from-primary/20 to-primary/5" />
                )}

                {/* Content */}
                <article className="p-5">
                  <h2 className="text-lg font-semibold mb-2 group-hover:text-primary transition-colors line-clamp-2">
                    {post.title}
                  </h2>
                  <p className="text-muted-foreground text-sm mb-4 line-clamp-2">
                    {post.description}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <time dateTime={post.date}>{formatBlogDate(post.date)}</time>
                    <span className="text-border">|</span>
                    <span>{post.author}</span>
                  </div>
                </article>
              </Card>
            </Link>
          ))}
        </div>

        {/* Empty state */}
        {visibleBlogPosts.length === 0 && (
          <div className="max-w-4xl mx-auto">
            <Card className="p-8 text-center">
              <p className="text-muted-foreground">No blog posts yet. Check back soon!</p>
            </Card>
          </div>
        )}
      </div>
    </>
  )
}
